import React, { FC } from 'react';
import classNames from 'classnames';
import Button from 'atomic/button';
import Icon from 'atomic/icon';
import { OptionDataInterface } from 'modules/product/views/components/product-offers-header/interfaces/option.data.interface';
import { FILTER_GROUPS } from 'modules/product/views/components/product-offers-header/data/filter-options.data';
import ProductOffersFilterCheckbox from 'modules/product/views/components/product-offers-header/components/product-offers-filter-checkbox';
import OfferInterface from 'interfaces/offer.interface';
import getFiltersOffersCount from 'helpers/get-filters-offers-count';
import hasActiveFilter from 'helpers/has-active-filter';
import './product-offers-filters-menu-desktop.scss';

interface ProductOffersFiltersMenuDesktopProps {
    filters: OptionDataInterface[];
    activeFilters: string[];
    onSubmit: (filters: string[]) => void;
    onChange: (filters: string[]) => void;
    className?: string;
    offers: OfferInterface[];
}

const ProductOffersFiltersMenuDesktop: FC<ProductOffersFiltersMenuDesktopProps> = ({
    filters,
    activeFilters,
    onSubmit,
    className,
    onChange,
    offers
}) => {
    const filteredOffers = offers.filter(offer => hasActiveFilter(activeFilters, offer));
    const offersCount = getFiltersOffersCount(filteredOffers);

    const onChangeFilter = (filter: OptionDataInterface): void => {
        const isSelected = activeFilters.includes(filter.value);
        const selectedFilters = isSelected ? activeFilters.filter(item => item !== filter.value) : [...activeFilters, filter.value];

        onChange(selectedFilters);
    };

    const onSubmitFilters = (): void => {
        onSubmit(activeFilters);
    };

    const onClearFilters = (): void => {
        onChange([]);
    };

    return (
        <div className={classNames('product-offers-filters-menu', className)}>
            <ul className="product-offers-filters-menu__list">
                {FILTER_GROUPS.map(item => (
                    <li className="product-offers-filters-menu__item" key={item.value}>
                        <h5 className="product-offers-filters-menu__title">{item.label}</h5>
                        {filters.filter(filter => filter.group === item.value).map(item => (
                            <ProductOffersFilterCheckbox
                                key={item.value}
                                filter={item}
                                onFilterChange={onChangeFilter}
                                isChecked={activeFilters.includes(item.value)}
                                count={offersCount[item.value]}
                            />
                        ))}
                    </li>
                ))}
            </ul>
            <div className="product-offers-filters-menu__buttons">
                <Button
                    className={classNames({
                        'product-offers-filters-menu__button': true,
                        'product-offers-filters-menu__button--clear': true
                    })}
                    color="flat"
                    onClick={onClearFilters}
                    size="sm"
                >
                    <Icon name="x" size={16} color="primary" />
                    Wyczyść filtry
                </Button>
                <Button
                    className={classNames({
                        'product-offers-filters-menu__button': true,
                        'product-offers-filters-menu__button--submit': true
                    })}
                    size="sm"
                    color="primary"
                    onClick={onSubmitFilters}
                >
                    Pokaż oferty ({ filteredOffers.length })
                </Button>
            </div>
        </div>
    );
};

export default ProductOffersFiltersMenuDesktop;
